module.exports = __webpack_public_path__ + "static/media/gt.66e9b2ee.svg";